// libs
import React, { memo } from 'react';

// components
import ProductImage from 'shared/layouts/DetailsPage/components/ProductImage/Desktop';
import ProductInfo from 'shared/layouts/DetailsPage/components/ProductInfo/Desktop';
import RecentlyViewedObserver from 'layouts/DetailsPage/components/RecentlyViewedObserver';

// styles
import {
  DetailContainer,
  ImageContainerMobile,
  ImageContainerDesktop,
  ProductInfoContainer,
} from './styles';

// context
import { useResponsiveContext } from 'shared/components/ResponsiveLoader/ResponsiveContext';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

function ProductDetail() {
  const { deviceWidth } = useResponsiveContext();
  const ImageContainer =
    deviceWidth && deviceWidth > BREAKPOINTS.DESKTOP ? ImageContainerDesktop : ImageContainerMobile;
  return (
    <>
      <DetailContainer>
        <ImageContainer>
          <ProductImage />
        </ImageContainer>
        <ProductInfoContainer>
          <ProductInfo />
        </ProductInfoContainer>
      </DetailContainer>
      <RecentlyViewedObserver />
    </>
  );
}

export default memo(ProductDetail);
